import React, { useState } from 'react'
 
 
import AgronomyCommercialRecommendationList from './AgronomyCommercialRecommendationList';
import AgronomyCommercialRecommendationForm from './AgronomyCommercialRecommendationForm';

const AgronomyCommercialRecommendation= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <AgronomyCommercialRecommendationForm addForm={setFromIsShown} update={upData} />
        ) : (
          <AgronomyCommercialRecommendationList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default AgronomyCommercialRecommendation